import React, { useState, useContext, useEffect } from 'react';

import { onAuthStateChanged, signOut } from 'firebase/auth';

import { AuthenticatedUserContext } from '../providers';

import { auth } from '../config';

import Login from '../screens/Login';
import OnboardingFestival from '../components/Onboarding/OnboardingFestival';
import Error from '../screens/Error';
import PublicShare from '../components/Share/PublicShare';

import Launch from '../screens/Launch';
import SplashScreen from '../components/Onboarding/SplashScreen';
import Loading from '../components/UI/Loading';

import { createBrowserRouter, RouterProvider } from 'react-router-dom'

import UserContextProvider from '../store/user-context';

const router = createBrowserRouter([
  { path: '/', element: <Login/>, errorElement: <Error />},
  { path: '/share/:groupId', element: <PublicShare/> },
  { path: '/share/:groupId/:memberId', element: <PublicShare/> },
])


export const RootNavigator = () => {
  const { user, setUser, showLogin, setShowLogin, loginMode, setLoginMode } = useContext(AuthenticatedUserContext);
  const [isLoading, setIsLoading] = useState(true);
  const [showSplash, setShowSplash] = useState(true);

  useEffect(() => {
    // onAuthStateChanged returns an unsubscriber
    const unsubscribeAuthStateChanged = onAuthStateChanged(
      auth,
      authenticatedUser => {
        if (authenticatedUser && authenticatedUser.isAnonymous) {
          // Anonymous auth was a deprecated guest-mode feature — a session
          // from before it was removed can still be sitting in the browser
          // and would otherwise route straight into the full app with no
          // way to reach sign up/login. Treat it as a fresh, unauthenticated
          // visitor instead; any data tied to that anonymous uid is abandoned.
          setUser(null);
          setIsLoading(false);
          signOut(auth).catch(() => {});
          return;
        }
        authenticatedUser ? setUser(authenticatedUser) : setUser(null);
        setIsLoading(false);
      }
    );
   // unsubscribe auth listener on unmount
    return unsubscribeAuthStateChanged;
  }, [user]);

 
  // Public share links must work without auth or splash
  if (window.location.pathname.startsWith('/share/')) {
    return <PublicShare />;
  }

  if (showSplash) {
    return <SplashScreen onContinue={() => setShowSplash(false)} />
  }

  if (isLoading) {
    return ( <Loading msg='Loading' />)
  }

  return (

    <>

    {user ?

    <UserContextProvider>
      <Launch />
    </UserContextProvider>

    : showLogin 
      ? <Login initialMode={loginMode} onBack={() => setShowLogin(false)} /> 
      : <OnboardingFestival group={{id: null}} showBack={false} onSignIn={(mode) => { setLoginMode(mode || 'signup'); setShowLogin(true); }} />

    }

    </>
      
  );
};
